import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes.js";
import ScrollToSection from "./components/ScrollToSection"// Importar la nueva función

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToSection />
        <Routes />
      </Router>
    </div>
  );
}

export default App;
